import React, { useEffect } from "react";
import UpdatesContent from "./updates/updates-content";

const News = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <UpdatesContent />
  )
}

export default News;
